<template>
  <div class="yearlyconfirm">
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">确认支付</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 购买服务顶部 开始 -->
    <div class="yearlyconfirm_top">
      <img class="yearlyconfirm_img" src="/static/nianshen.png" />
      <div class="yearlyconfirm_name">{{yearConfirmMesg.serviceName}}</div>
      <div class="yearlyconfirm_mesgtip">{{yearConfirmMesg.Drivingtype ? '说明：年检检测费由上门接送人员代收' : '说明：年检检测费请交到检测站前台'}}</div>
      <div class="yearlyconfirm_mesgtip">（具体年检检测费按检测站公示价为准）</div>
    </div>
    <!-- 购买服务顶部 结束 -->
    <!-- 商品信息 开始 -->
    <div class="yearlyconfirm_shangpinmesg">
      <div class="yearlyconfirm_shangpin_title">
        <img class="yearlyconfirm_shangpin_title_icon" src="/static/newprojecticon/title.png" />
        <div class="yearlyconfirm_shangpin_title_name">商品信息</div>
      </div>
    <!--  <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">车辆检测费</div>
        <div class="yearlyconfirm_shangpin_shoujia">￥{{yearConfirmMesg.price}}</div>
      </div> -->
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">服务费</div>
        <div class="yearlyconfirm_shangpin_shoujia">￥{{yearConfirmMesg.service_price}}</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">车辆信息</div>
        <div class="yearlyconfirm_shangpin_shoujia">{{yearConfirmMesg.car_no}}</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">联系人姓名</div>
        <div class="yearlyconfirm_shangpin_shoujia">{{yearConfirmMesg.name}}</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">联系人电话</div>
        <div class="yearlyconfirm_shangpin_shoujia">{{yearConfirmMesg.phone}}</div>
      </div>
      <div class="yearlyconfirm_shangpin_box" v-if="yearConfirmMesg.address">
        <div class="yearlyconfirm_shangpin_mesgname">详细地址</div>
        <div class="yearlyconfirm_shangpin_shoujia">{{yearConfirmMesg.address}}</div>
      </div>
      <div class="yearlyconfirm_shangpin_box" v-if="yearConfirmMesg.storeName">
        <div class="yearlyconfirm_shangpin_mesgname">预约店铺</div>
        <div class="yearlyconfirm_shangpin_shoujia">{{yearConfirmMesg.storeName}}</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">预约日期</div>
        <div class="yearlyconfirm_shangpin_shoujia">{{yearConfirmMesg.book_date}}</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">预约时间</div>
        <div class="yearlyconfirm_shangpin_shoujia">{{yearConfirmMesg.book_time}}</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">总价</div>
        <div class="yearlyconfirm_shangpin_shoujia">￥{{totalPrice}}</div>
      </div>
    </div>
    <!-- 商品信息 结束 -->
    <!-- 注意事项 开始 -->
    <div class="page_mesg yearlyconfirm_mesgs">
      <div class="page_mesgtitle">
        <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
        <div class="page_mesgtext">提示</div>
      </div>
      <div class="page_mesgtip">可能有待处理违章信息<span class="page_mesgtipspan">{{violationQueryNum}}</span>条</div>
    </div>
    <!-- 注意事项 结束 -->
    <!-- 违章信息 开始 -->
    <!-- <div class="yearlyconfirm_shangpinmesg">
      <div class="yearlyconfirm_shangpin_title">
        <img class="yearlyconfirm_shangpin_title_icon" src="/static/newprojecticon/title.png" />
        <div class="yearlyconfirm_shangpin_title_name">违章信息</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">违法时间</div>
        <div class="yearlyconfirm_shangpin_shoujia">2020-05-02 14:15:22</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">违法地点</div>
        <div class="yearlyconfirm_shangpin_shoujia">中山市市区路段</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">违法行为</div>
        <div class="yearlyconfirm_shangpin_shoujia">闯红灯</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">采集机关</div>
        <div class="yearlyconfirm_shangpin_shoujia">中山市交警南区支队</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">违法记分数</div>
        <div class="yearlyconfirm_shangpin_shoujia">6</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">罚款金额</div>
        <div class="yearlyconfirm_shangpin_shoujia">￥1000</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">交款标记</div>
        <div class="yearlyconfirm_shangpin_shoujia">未交款</div>
      </div>
      <div class="yearlyconfirm_shangpin_box">
        <div class="yearlyconfirm_shangpin_mesgname">处理标记</div>
        <div class="yearlyconfirm_shangpin_shoujia">未处理</div>
      </div>
    </div> -->

    <!-- 违章信息 结束 -->
    <!-- 支付方式 开始 -->
    <div class="yearlyconfirm_shangpinmesg1">
      <div class="yearlyconfirm_shangpin_title">
        <img class="yearlyconfirm_shangpin_title_icon" src="/static/newprojecticon/title.png" />
        <div class="yearlyconfirm_shangpin_title_name">支付方式</div>
      </div>
      <div class="yearlyconfirm_shangpin_cardbox" @click="showcardList()">
        <div class="yearlyconfirm_shangpin_mesgname1">
          <img src="/static/kaquanpay.png" class="yearlyconfirm_shangpin_mesglogo" />
          <div class="yearlyconfirm_shangpin_mesgname11">使用卡券</div>
        </div>
        <div class="yearlyconfirm_shangpin_usejifen">
          <div class="yearlyconfirm_shangpin_keyong">{{isCheckCard ? '已选' : '未选'}}</div>
          <div class="yearlyconfirm_shangpin_shoujia11">可用{{couponList.length}}张</div>
          <img :src="isCheckCard ? '/static/newicon/checkedicon.png' : '/static/newicon/checkicon.png'" class="checklogo" />
        </div>
      </div>
     <div class="yearlyconfirm_shangpin_box" @click="weixinPay()">
       <div class="yearlyconfirm_shangpin_mesgname1" style="width: 150px;">
          <img src="/static/weixinpay.png" class="yearlyconfirm_shangpin_mesglogo" />
          <div class="yearlyconfirm_shangpin_mesgname11">微信支付</div>
        </div>
        <div class="yearlyconfirm_shangpin_shoujia1">{{totalPricePaid}}元</div>
        <img :src="isWeixinPay? '/static/newicon/checkedicon.png' : '/static/newicon/checkicon.png'" class="checklogo" />
      </div>

      <!-- <div class="yearlyconfirm_shangpin_box" @click="yuePay()">
        <div class="yearlyconfirm_shangpin_mesgname1">
          <img src="/static/jifenpay.png" class="yearlyconfirm_shangpin_mesglogo" />
          <div class="yearlyconfirm_shangpin_mesgname11">积分支付</div>
        </div>
        <div class="yearlyconfirm_shangpin_usejifen">
          <div class="yearlyconfirm_shangpin_keyong">可用积分</div>
          <div class="yearlyconfirm_shangpin_shoujia11">{{amount}}</div>
          <img :src="isWeixinPay? '/static/newicon/checkicon.png' : '/static/newicon/checkedicon.png'" class="checklogo" />
        </div>
      </div> -->

    </div>
    <!-- 支付方式 结束 -->
    <!-- 支付 开始 -->
    <div class="page_button yearlyconfirm_button" @click="payment()">
      <div class="page_zhifu">确认支付</div>
    </div>
    <!-- 支付 结束 -->
    <!-- 卡券弹出层 开始 -->
    <van-popup v-model="showCardList" position="bottom" :style="{ height: '50%' }">
      <div class="cardlist_popup_top">
        <div class="cardlist_popup_topcancel" @click="cardListCancel()">取消</div>
        <div class="cardlist_popup_topcenter">选择卡券</div>
        <div class="cardlist_popup_topconfirm" @click="cardListConfirm()">确定</div>
      </div>
      <div class="cardlist_popup_list">

        <div v-for="(item,index) in couponList" @click="checkCardList(index)" class="cardlist_popup_box1">
          <!-- <div>{{item.checked}}</div> :class="item.checked ? ' : 'cardlist_popup_box12' -->
          <div>
            <div class="cardlist_popup_boxtop">卡券名称：{{item.related.name}}</div>
            <div class="cardlist_popup_boxbot">到期日期：{{item.overdue_at}}</div>
          </div>
          <img class="cardlist_popup_boxcheck" :src="item.checked ? '/static/newicon/checkedicon.png' : '/static/newicon/checkicon.png' " />
        </div>
        <!-- <img src="" /> -->
        <!-- <div class="cardlist_popup_box1">
          <div class="cardlist_popup_boxtop">卡券编号：2222222222</div>
          <div class="cardlist_popup_boxbot">到期日期：2020-09-23</div>
        </div> -->
      </div>
      <!-- <img class="cardlist_popup_img" src="/static/keyong.png" /> -->
      <!-- <img class="cardlist_popup_img" src="/static/bukeyong.png" /> -->
    </van-popup>
    <!-- 卡券弹出层 结束 -->
  </div>
</template>

<script>
  import httper from '../../api/http';
  import eventBus from '../../../static/js/eventbus.js';
  import {
    Dialog
  } from 'vant';
  export default {
    data() {
      return {
        userInfo: {},
        mobile: "",
        showItem: {}, //上个页面传来的值
        serviceItem: {
          item_id: '', //商品item_id
          name: '', // 商品名称
          originalPrice: '', // 商品原价
          discount: '', // 原价减去需支付金额得到商品优惠
          price: '', // 应付金额
          wxDiscount: '', // 微支付优惠(暂弃
          wxPrice: '', // 应付金额减去微支付优惠后得到的微信应付金额(暂弃
        }, // 上一页获取商品信息
        amount: '0.00', // 可用余额
        // settlementItem: {

        //   canAmountPay: false, // 前端计算可用余额是否大于服务价格,默认为false
        //   couponList: [], // 服务券列表,默认为空
        //   isAmountPay: false, // 用户是否使用余额结算,默认为false
        //   selectedID: '' // 用户选择服务券的编号,默认为空
        // }, // 接口获取结算方式
        maskStatus: '', // 遮盖层所展示的状态类型
        isMaskHidden: true, // 是否隐藏遮盖层,默认为true
        buttonClicked: false, // 防止支付重复点击,默认为false
        order_param: {},
        phoneNum: "",
        yearConfirmMesg: "", //上个页面传来信息
        showCardList: false, //是否显示弹框
        couponList: [], //服务券列表
        violationQueryNum: 0, //违章条数
        isWeixinPay: true,
        isCheckCard: false,
        totalPrice: "",
        selectedcardID: "",
        totalPricePaid: ""
      }
    },
    created() {
      if (this.$route.query.yearConfirmMesg) {
        this.yearConfirmMesg = JSON.parse(this.$route.query.yearConfirmMesg)
      }
      console.log("this.yearConfirmMesg", this.yearConfirmMesg)
      this.totalPrice = parseFloat(this.yearConfirmMesg.price) + parseFloat(this.yearConfirmMesg.service_price)
      this.totalPricePaid = this.totalPrice
      this.request('getUserInfo')
      this.request("getCouponList", {
        status: 0,
        type: "annual_review"
      })
      this.request("getCarViolation", {
        driving_license_id: this.yearConfirmMesg.driving_license_id
      })
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        // let address = this.data.yearConfirmMesg.address
        // eventBus.$emit('address',address);
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true;
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === "number") {
            setTimeout(() => {
              this.buttonClicked = false;
            }, duration);
          }
          resolve(true);
        });
      },
      //使用卡券显示弹出层
      showcardList() {
        if (this.couponList.length == 0) {
          this.$toast({
            message: '暂无可用券',
          })
          return
        } else {
          this.showCardList = true
        }

      },
      //卡券列表取消事件
      cardListCancel() {
        let that = this
        this.showCardList = false
        this.isCheckCard = false
        that.totalPricePaid = that.totalPrice
      },
      //卡券列表点击确认事件
      cardListConfirm() {
        //let that = this
        // this.showCardList = false
        // that.isCheckCard = true
        //that.totalPricePaid = that.yearConfirmMesg.price

        let that = this
        if (!!that.selectedcardID) {
          this.showCardList = false
          that.isCheckCard = true
          that.totalPricePaid = that.yearConfirmMesg.price
        } else {
          this.showCardList = false
          this.isCheckCard = false
          that.totalPricePaid = that.totalPrice
        }
      },
      //选择卡券
      checkCardList(e) {
        let that = this
        let couponlist = this.couponList
        couponlist.map(function(item, i) {
          if (i == Number(e)) {
            console.log("item.checked", item.checked)
            item.checked = !item.checked
            if (item.checked) {
              that.selectedcardID = item.id;
            } else {
              that.selectedcardID = ""
            }
            // item.checked = true
            // that.selectedcardID = item.id;
            // that.isCheckCard = true
            // that.totalPricePaid = that.yearConfirmMesg.price
          } else {
            item.checked = false;
          }
        })
        that.couponList = couponlist;
        console.log("that.couponList", that.couponList)
        // that.isAmountPay = false;
        // that.isWeixinPay = false
      },
      //微信支付
      weixinPay() {
        this.isWeixinPay = true
      },
      //余额支付
      yuePay() {
        this.isWeixinPay = false
      },
      //确认支付
      payment() {
        let that = this
        let requestData = {}
        this.buttonClickedFun(1000) // 防止重复点击
        if ((!this.mobile)) {
          Dialog.confirm({
              title: '提示',
              message: '请先绑定手机',
            })
            .then(() => {
              that.$router.push({
                path: "/changePhoneNum"
              })
            })
            .catch(() => {
              return false;
            });
        }
        console.log("yearConfirmMesg", that.yearConfirmMesg)
        if (this.isCheckCard) {
          console.log("选择卡券")
          requestData = {
            username: that.yearConfirmMesg.name,
            mobile: that.yearConfirmMesg.phone,
            address: that.yearConfirmMesg.address,
            driving_license_id: that.yearConfirmMesg.driving_license_id,
            product_id: that.yearConfirmMesg.product_id,
            book_date: that.yearConfirmMesg.book_date,
            book_time: that.yearConfirmMesg.book_time,
            coupon_id: that.selectedcardID,
            amount: that.totalPrice,
            store_id: that.yearConfirmMesg.store_id,
            product_item_id: that.yearConfirmMesg.product_item_id,
            city: that.yearConfirmMesg.city,
            longitude: that.yearConfirmMesg.lng,
            latitude: that.yearConfirmMesg.lat,
            type: 'annual_review'
          }
        } else {
          requestData = {
            username: that.yearConfirmMesg.name,
            mobile: that.yearConfirmMesg.phone,
            address: that.yearConfirmMesg.address,
            driving_license_id: that.yearConfirmMesg.driving_license_id,
            product_id: that.yearConfirmMesg.product_id,
            book_date: that.yearConfirmMesg.book_date,
            book_time: that.yearConfirmMesg.book_time,
            amount: that.totalPrice,
            store_id: that.yearConfirmMesg.store_id,
            product_item_id: that.yearConfirmMesg.product_item_id,
            city: that.yearConfirmMesg.city,
            longitude: that.yearConfirmMesg.lng,
            latitude: that.yearConfirmMesg.lat,
            type: 'annual_review'
          }
        }
        // pay_type:"balance",

        if (that.isWeixinPay) {
          Dialog.confirm({
              title: '提示',
              message: '是否用微信支付?',
            })
            .then(() => {
              requestData.pay_type = 'wechatpay'
              that.request('WxunifiedOrder', requestData)
            })
            .catch(() => {
              return false;
            });
        } else {
          if (parseFloat(that.amount) < parseFloat(this.yearConfirmMesg.price)) {
            Dialog.confirm({
                title: '提示',
                message: '积分不足，前往充值？',
              })
              .then(() => {
                that.$router.push({
                  path: "/account"
                })
              })
              .catch(() => {
                return false;
              });
          } else {
            Dialog.confirm({
                title: '提示',
                message: '是否用余额支付?',
              })
              .then(() => {
                requestData.pay_type = "balance"
                that.request('YeunifiedOrder', requestData)
              })
              .catch(() => {
                return false;
              });
          }
        }
      },

      // 调用接口
      request(type = "", requestData = {}) {
        let that = this
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code == 0) {
                that.userInfo = res.data
                that.mobile = res.data.mobile

                var amount1 = res.data.account.amount.toFixed(2)
                that.amount = amount1
              }
            }, true)
            break
            //卡券列表
          case "getCouponList":
            httper.post("coupon/package-list", requestData, res => {
              let list = [];
              if (res.data) {
                //console.log("res.data", res.data)
                // console.log("that.id", that.id)
                // res.data.map(function(item, i) {
                //   if (item.product_item_id == that.id && item.type == 2 && item.status != 2) {
                //     list.push(item)
                //   }
                // })
                //that.couponList = res.data;

                console.log("res.data", res.data)
                res.data.map(function(item, i) {
                  item.checked=false
                    list.push(item)
                })
                that.couponList = list;
                console.log("that.couponList",that.couponList)
              }
            });
            break;
            //违章查询
          case "getCarViolation":
            httper.post("/car/violation-query", requestData, res => {
              console.log("res", res)
              if (res.code === 0) {
                this.violationQueryNum = res.data
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            });
            break;
            //余额支付
          case 'YeunifiedOrder':
            httper.post('/payment/place-order', requestData, res => {
              if (res.code === 0) {
                this.$router.push({
                  path: "orderListDetail",
                  query: {
                    id: res.data.order_no
                  }
                })
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信下单
          case 'WxunifiedOrder':
            httper.post('/payment/place-order', requestData, res => {
              console.log("微信支付信息", res)
              if (res.code === 0) {
                if(res.data.payment_packet){
                  that.pay(res.data.payment_packet, res.data.order_no)
                }else{
                  this.$toast({
                    message: '下单成功',
                  })
                  that.$router.push({
                    path: '/orderListDetail',
                    query: {
                      id: res.data.order_no
                    }
                  })
                }
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
            //微信取消下单
          case 'orderCancel':
            httper.post('/order/cancel', requestData, res => {
              console.log("取消", res)
              if (res.code === 0) {
                // that.pay(res.data.payment_packet, res.data.order_no)
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, true)
            break
        }
      },
      //发起支付
      pay(payment_packet, order_no) {
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
            document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(payment_packet, order_no));
          }
        } else {
          this.jsApiCall(payment_packet, order_no);
        }
      },
      //调用微信支付
      jsApiCall(payment_packet, order_no) {

        let that = this
        if (!payment_packet) {
          this.$toast({
            message: '下单失败，请重试',
          })
          return
        }
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', payment_packet,
          function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠
              //跳去详情页order_no
              that.$router.push({
                path: '/orderListDetail',
                query: {
                  id: order_no
                }
              })
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
              this.$toast({
                message: '取消支付'
              })
              this.request("orderCancel", {
                order_id: order_no
              })
              // that.$router.push({
              //   name: 'list'
              // })
            } else {
              this.$toast({
                message: '支付失败',
              })
            }
          }
        )
      },
    }
  }
</script>

<style scoped>
  .yearlyconfirm {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .yearlyconfirm_top {
    margin: 10px 0;
    width: 90%;
    height: 134px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 4px 1px rgba(187, 187, 187, 0.3);
    border-radius: 7px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .yearlyconfirm_img {
    width: 35px;
    height: 35px;
    margin-bottom: 10px;
  }

  .yearlyconfirm_name {
    font-size: 19px;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }

  .yearlyconfirm_shangpin_title {
    display: flex;
    align-items: center;
  }

  .yearlyconfirm_shangpin_title_icon {
    width: 3px;
    height: 23px;
    margin-right: 10px;
  }

  .yearlyconfirm_shangpin_title_name {
    font-size: 15px;
    font-weight: 400;
    color: rgba(53, 53, 53, 1);
  }



  .yearlyconfirm_shangpinmesg {
    width: 90%;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 4px 1px rgba(187, 187, 187, 0.3);
    border-radius: 7px;
    margin-bottom: 10px;
  }

  .yearlyconfirm_shangpinmesg1 {
    width: 90%;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 4px 1px rgba(187, 187, 187, 0.3);
    border-radius: 7px;
    margin-top: 10px;
  }

  .yearlyconfirm_shangpin_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }

  .yearlyconfirm_shangpin_cardbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #BFBFBF;
  }

  .yearlyconfirm_shangpin_mesgname {
    font-size: 11px;
    font-weight: 400;
    color: rgba(101, 101, 101, 1);
    width: 20%;
  }

  .yearlyconfirm_shangpin_mesgname1 {
    font-size: 15px;
    font-weight: 400;
    color: rgba(53, 53, 53, 1);
    display: flex;
    align-items: center;
  }

  .yearlyconfirm_shangpin_mesgname11 {
    font-size: 11px;
    font-weight: 400;
    color: rgba(101, 101, 101, 1);
  }

  .yearlyconfirm_shangpin_mesglogo {
    width: 17px;
    height: 17px;
    margin-right: 10px;
  }

  .yearlyconfirm_shangpin_shoujia {
    font-size: 11px;
    font-weight: 400;
    color: #FD8C00;
    width: 80%;
    display: flex;
    justify-content: flex-end;
  }

  .yearlyconfirm_shangpin_shoujia1 {
    font-size: 11px;
    font-weight: 400;
    color: #FD8C00;
    width: 72%;
    display: flex;
    justify-content: flex-end;
  }

  .yearlyconfirm_shangpin_shoujia11 {
    font-size: 11px;
    font-weight: 400;
    color: #FD8C00;
    display: flex;
    justify-content: flex-end;
  }

  .yearlyconfirm_button {
    /* margin-top: 20px; */
    /* position: fixed;
    bottom: 10px; */
    width: calc(100% - 40px);
    margin: 20px;
  }

  .yearlyconfirm_shangpin_usejifen {
    display: flex;
    align-items: center;
  }

  .yearlyconfirm_shangpin_keyong {
    font-size: 12px;
    color: #666666;
    margin-right: 10px;
  }

  .checklogo {
    width: 15px;
    height: 15px;
    margin-left: 10px;
  }

  .cardlist_popup_top {
    width: 100%;
    height: 18%;
    padding: 10px 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    border-bottom: 1px solid #EEEEEE;
  }

  .cardlist_popup_topcancel {
    font-size: 14px;
    color: #969799;
  }

  .cardlist_popup_topcenter {
    font-size: 16px;
  }

  .cardlist_popup_topconfirm {
    font-size: 14px;
    color: #576b95;
  }

  .cardlist_popup_list {
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;

  }

  .cardlist_popup_box {
    width: 100%;
    height: 77px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background-color: #EEEEEE;
    border-radius: 8px;
  }

  .cardlist_popup_box1 {
    width: 100%;
    height: 77px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background-color: #FFFFFF;
    border: 1px solid #FD8C00;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .cardlist_popup_box12 {
    width: 100%;
    height: 77px;
    padding: 10px 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
    background-color: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .cardlist_popup_boxtop {
    color: #363636;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .cardlist_popup_boxbot {
    color: #BBBBBB;
    font-size: 14px;
  }

  .cardlist_popup_img {
    position: absolute;
    top: 0;
    right: 0;
    width: 69px;
    height: 23px;
  }

  .yearlyconfirm_mesgs {
    width: calc(100% - 40px);
    margin: 0 20px;
    box-shadow: 0 3px 4px 1px rgba(187, 187, 187, 0.3);
    border-radius: 7px;
    box-sizing: border-box;
    padding: 10px;
  }

  .cardlist_popup_boxcheck {
    width: 15px;
    height: 15px;
    margin-right: 10px;
  }
  .yearlyconfirm_mesgtip {
    font-size: 14px;
    color: rgba(233, 109, 85, 1);
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/yearlyconfirm.vue